import { useRef, useState, useCallback, useLayoutEffect, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SEO from '@components/SEO'
import KrpanoViewer from '@components/KrpanoViewer'
import BlurHashImage from '@components/BlurHashImage'
import KrpanoCompass from '@components/KrpanoCompass'
import { BLUR_HASH_MAP } from '@constants/BlurHashItems'
import { ROUTES } from '@constants'
import './TongQuanPage.css'

// Đường dẫn tới thư mục tour 360 tổng quan (tương đối với public/)
const SCENE_FOLDER  = `${import.meta.env.BASE_URL}360/tongquan`
const SCRIPT_SRC    = `${import.meta.env.BASE_URL}360/tongquan/tour.js`
const COMPASS_IMGS  = `${import.meta.env.BASE_URL}360/tongquan/images`
const START_SCENE   = 'scene_tong_quan'
// Fallback: tự ẩn blur sau 20s nếu krpano bị lỗi không ready
const FALLBACK_MS   = 20_000

function TongQuanPage() {
  const krpanoRef        = useRef(null)
  const readyTimerRef    = useRef(null)
  const [isReady, setIsReady] = useState(false)
  const navigate         = useNavigate()

  // Đăng ký global callback để krpano có thể navigate sang trang Tiện Ích với scene cụ thể
  useEffect(() => {
    window.navigateToTienIch = (scene) => {
      navigate(`${ROUTES.TIEN_ICH}${scene ? `?startscene=${scene}` : ''}`)
    }
    return () => { window.navigateToTienIch = null }
  }, [navigate])

  // Tránh màn hình flash: overlay blurhash hiện ngay khi trang mount
  useLayoutEffect(() => {
    setIsReady(false)
    const t = window.setTimeout(() => {
      setIsReady(ready => (ready ? ready : true))
    }, FALLBACK_MS)
    return () => window.clearTimeout(t)
  }, [])

  // Cleanup ready timer on unmount to prevent setState on unmounted component
  useEffect(() => {
    return () => { clearTimeout(readyTimerRef.current) }
  }, [])

  const handleKrpanoReady = useCallback(() => {
    // Delay nhỏ để krpano render frame đầu trước khi ẩn overlay
    readyTimerRef.current = window.setTimeout(() => setIsReady(true), 100)
  }, [])

  return (
    <div className="tongquan-page">
      <SEO
        title="Tổng Quan"
        description="Khám phá toàn cảnh dự án Fenica qua góc nhìn 360 độ sống động."
      />

      {/* ── Krpano viewer ── */}
      <KrpanoViewer
        ref={krpanoRef}
        scriptSrc={SCRIPT_SRC}
        sceneFolder={SCENE_FOLDER}
        startScene={START_SCENE}
        onReady={handleKrpanoReady}
      />

      {/* ── Blurhash loading overlay ── */}
      <div
        className={`tongquan-page__blur-overlay${isReady ? ' tongquan-page__blur-overlay--ready' : ''}`}
        aria-hidden="true"
      >
        <BlurHashImage
          hash={BLUR_HASH_MAP.tongquan}
          fadeOut={isReady}
        />
      </div>

      {/* ── React Compass ── */}
      <KrpanoCompass
        krpanoRef={krpanoRef}
        imagesBase={COMPASS_IMGS}
        visible={isReady}
      />
    </div>
  )
}

export default TongQuanPage
